import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios";

const TABLES_URL = "/api/table";

const TableList = () => {
  const [tables, setTables] = useState([]);
  const [filteredTables, setFilteredTables] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState("rooftop");
  const navigate = useNavigate();

  const fetchTables = async () => {
    try {
      const response = await axios.get(TABLES_URL);
      setTables(response.data);
      setFilteredTables(response.data.filter((table) => table.place === "rooftop"));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTables();
  }, []);

  const handleFilter = (place) => {
    setSelectedPlace(place);
    setFilteredTables(tables.filter((table) => table.place === place));
  };

  const rooftopLayout = [
    { tableNumber: 105, shape: "square", gridArea: "1 / 1 / 2 / 2" },
    { tableNumber: 106, shape: "square", gridArea: "1 / 2 / 2 / 3" },
    { tableNumber: 107, shape: "square", gridArea: "1 / 3 / 2 / 4" },
    { tableNumber: 108, shape: "square", gridArea: "1 / 4 / 2 / 5" },
    { tableNumber: 111, shape: "square", gridArea: "1 / 7 / 2 / 8" },
    { tableNumber: 112, shape: "square", gridArea: "1 / 8 / 2 / 9" },
    { tableNumber: 104, shape: "square", gridArea: "2 / 1 / 3 / 2" },
    { tableNumber: 109, shape: "square", gridArea: "2 / 4 / 3 / 5" },
    { tableNumber: 110, shape: "rectangle", gridArea: "2 / 5 / 3 / 7" },
    { tableNumber: 114, shape: "square", gridArea: "2 / 8 / 3 / 9" },
    { tableNumber: 103, shape: "square", gridArea: "3 / 1 / 4 / 2" },
    { tableNumber: 102, shape: "circle", gridArea: "3 / 2 / 4 / 3" },
    { tableNumber: 101, shape: "circle", gridArea: "3 / 3 / 4 / 4" },
    { tableNumber: 116, shape: "square", gridArea: "3 / 7 / 4 / 8" },
    { tableNumber: 115, shape: "square", gridArea: "3 / 8 / 4 / 9" }
  ];

  const salonLayout = [
    { tableNumber: 204, shape: "square", gridArea: "1 / 1 / 2 / 2" },
    { tableNumber: 205, shape: "square", gridArea: "1 / 2 / 2 / 3" },
    { tableNumber: 206, shape: "square", gridArea: "1 / 3 / 2 / 4" },
    { tableNumber: 207, shape: "square", gridArea: "1 / 4 / 2 / 5" },
    { tableNumber: 208, shape: "square", gridArea: "1 / 5 / 2 / 6" },
    { tableNumber: 209, shape: "square", gridArea: "1 / 6 / 2 / 7" },
    { tableNumber: 210, shape: "square", gridArea: "2 / 6 / 3 / 7" },
    { tableNumber: 211, shape: "square", gridArea: "3 / 6 / 4 / 7" },
    { tableNumber: 203, shape: "square", gridArea: "2 / 1 / 3 / 2" },
    { tableNumber: 202, shape: "square", gridArea: "3 / 1 / 4 / 2" },
    { tableNumber: 201, shape: "square", gridArea: "3 / 2 / 4 / 3" },
    { type: "door", gridArea: "3 / 3 / 4 / 4" },
    { tableNumber: 215, shape: "square", gridArea: "3 / 4 / 4 / 5" },
    { tableNumber: 214, shape: "square", gridArea: "3 / 5 / 4 / 6" },
    { tableNumber: 212, shape: "square", gridArea: "3 / 6 / 4 / 7" }
  ];

  const getTableStatus = (tableNumber) => {
    const tableData = filteredTables.find(t => t.tableNumber === tableNumber);
    return {
      isReserved: tableData?.reserver || false,
      tableId: tableData?._id || null
    };
  };

  return (
    <div className="w-full flex flex-col">
      <div className="flex gap-4 mb-4">
        <button
          onClick={() => handleFilter("rooftop")}
          className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 shadow-md ${selectedPlace === "rooftop"
              ? "bg-[#610c63] text-white shadow-lg scale-105"
              : "bg-gray-300 text-gray-700 hover:bg-[#610c63] hover:text-white"
            }`}
        >
          ROOFTOP
        </button>
        <button
          onClick={() => handleFilter("salon")}
          className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 shadow-md ${selectedPlace === "salon"
              ? "bg-[#610c63] text-white shadow-lg scale-105"
              : "bg-gray-300 text-gray-700 hover:bg-[#610c63] hover:text-white"
            }`}
        >
          SALON
        </button>
      </div>

      <div className={`w-full h-screen p-8 rounded-lg shadow-lg ${selectedPlace === "salon" ? "bg-gray-500" : "bg-white"}`}>
        <div className="grid grid-cols-15 gap-6" style={{ minHeight: "300px" }}>
          {(selectedPlace === "rooftop" ? rooftopLayout : salonLayout).map((item, index) => {
            if (item.type === "door") {
              return (
                <div
                  key={`door-${index}`}
                  style={{ gridArea: item.gridArea }}
                  className="h-24 flex items-center justify-center"
                >
                </div>
              );
            }

            const { isReserved, tableId } = getTableStatus(item.tableNumber);
            return (
              <div
                key={item.tableNumber}
                style={{
                  gridArea: item.gridArea,
                  border: selectedPlace === "salon" ? "2px solid #FFD700" : "2px solid rgb(47, 192, 34)",
                }}
                className={` 
                    ${item.shape === "circle" ? "rounded-full" : "rounded-lg"} 
                    ${item.shape === "rectangle" ? "col-span-2" : ""} 
                    ${item.shape === "circle" ? "mt-16" : ""} 
                    h-32 flex items-center justify-center 
                    cursor-pointer transition-all duration-300 
                    ${isReserved ? (selectedPlace === "salon" ? "bg-yellow-400" : "bg-green-500") : "bg-gray-300"} 
                    hover:scale-105 hover:shadow-xl 
                    relative 
                    ${!tableId && 'opacity-50 cursor-not-allowed'} 
                  `}
                onClick={() => {
                  if (tableId) {
                    navigate(`${tableId}`);
                  }
                }}
              >
                <span className={`font-bold text-gray-800`}>
                  {item.tableNumber}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TableList;